import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'demo-upp-address',
    templateUrl: './demo-upp-address.html',
    styleUrls: ['../demo-common.scss', './demo-upp-address.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppAddressComponent implements OnInit {
    form!: FormGroup;

    constructor(private change: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.form = new FormGroup({
            address: new FormControl(null),
        });
    }

    get formValueJson(): string {
        return JSON.stringify(this.form.value, null, 2);
    }
}
